
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as allq3vmD60yZgmDWhHuyqMNr9W53WRTda7MzR5Pw4lCEmAMeta } from "/app/apps/web-commerce/pages/all.vue?macro=true";
import { default as otp_45Szb5OOKB3l6cGUYaZUl_45GS5uHyBVIKsgRIXUIBUtr4Meta } from "/app/apps/web-commerce/pages/otp.vue?macro=true";
import { default as authROz2bQ4nSS0WnD6Mwfzu9wMgw1ukd4YFFaxd01d3NOYMeta } from "/app/apps/web-commerce/pages/auth.vue?macro=true";
import { default as indexbwhrEinRVbqK48qNztTG83jwKiYlEVe3Dmo62obG_45kMMeta } from "/app/apps/web-commerce/pages/index.vue?macro=true";
import { default as topuptplMXN_45M1FRQla6s2v28iNW6fpm7BbK7aZ5s2z2_45zMQMeta } from "/app/apps/web-commerce/pages/topup.vue?macro=true";
import { default as _91slug_93dJADup78XB7DJjZJt4vT_W6Xd3YOCspgx_45_AnFK4o90Meta } from "/app/apps/web-commerce/pages/[slug].vue?macro=true";
import { default as customySENJhq58yZYNlM0P_453cYIX6ETqvoGtgJFWjGipm9g0Meta } from "/app/apps/web-commerce/pages/custom.vue?macro=true";
import { default as ordersFvAzZYgB_45XFsfarY3saRnjHpx96TIXq_OZE_45Q5YOL38Meta } from "/app/apps/web-commerce/pages/orders.vue?macro=true";
import { default as searchPpAORWk9tsXd9IZdw2SVISYlHv50V_Z_45E3ouJ5y5j4wMeta } from "/app/apps/web-commerce/pages/search.vue?macro=true";
import { default as walletyDMxcG7dvvuRblasrqou9aSaSYCEC2LTAX0ZD9dNItcMeta } from "/app/apps/web-commerce/pages/wallet.vue?macro=true";
import { default as library0Q1_7RaSZSXey6_WdBy4HUH_t4Pv7Jy6PLpt5OaL6sYMeta } from "/app/apps/web-commerce/pages/library.vue?macro=true";
import { default as paymentzg4osBUgYjliIl20f_454drhPkO_45hfKl_YpOZUk_r0wVUMeta } from "/app/apps/web-commerce/pages/payment.vue?macro=true";
import { default as profileL_Mdc0dY3pI3tTjkUBx7IYDjZdLIgSWA4zc9AvmSAgYMeta } from "/app/apps/web-commerce/pages/profile.vue?macro=true";
import { default as messagesp_45vjD1dDFNxpVNvfVb1Phz2KcQLH5pG0nsg0UIYpOqsMeta } from "/app/apps/web-commerce/pages/messages.vue?macro=true";
import { default as dashboardgcy5UN9nRug5oFWKKJUtMzPbmku1v5robjsjG4LjGvwMeta } from "/app/apps/web-commerce/pages/dashboard.vue?macro=true";
import { default as _91id_93KAmHjV_45PLeVlbAybS8hOf0pCC6y8aN42P9pVmF8XkHwMeta } from "/app/apps/web-commerce/pages/order/[id].vue?macro=true";
import { default as transactions0LE2l5AWRNw3hCoPY7dpvwTdnk_OolmC4Tysunnbf4gMeta } from "/app/apps/web-commerce/pages/transactions.vue?macro=true";
import { default as _91id_93p7Pd_qzb_J4wbQYPT_apOOWp0F9XohISs_7qp8xyVg0Meta } from "/app/apps/web-commerce/pages/giftcard/[id].vue?macro=true";
import { default as notificationsGEuGXLbhlpjabgXHrvxlt6pfgz2mgQlfjdOV9BNzs_cMeta } from "/app/apps/web-commerce/pages/notifications.vue?macro=true";
import { default as online_45paymentBZDdjMrDaKwUzwOh9JOMG_45ArLBz2LJvzgjZx_45PQ8ns8Meta } from "/app/apps/web-commerce/pages/online-payment.vue?macro=true";
import { default as _91id_93_45cB5tXmenFfwsNdHZMlu2fG5j8ZtWatLywhtQzVCp3AMeta } from "/app/apps/web-commerce/pages/order-old/[id].vue?macro=true";
import { default as _91slug_93E4jJPRv12_ly410_45HbrEQjnGrKQLDCNKQmiO6kvGLlAMeta } from "/app/apps/web-commerce/pages/category/[slug].vue?macro=true";
import { default as _91ok_93D193tlHXEj9sMjNL_SgUCB8XiQmC7UvDz8aKCQ6qiToMeta } from "/app/apps/web-commerce/pages/pay-result/[ok].vue?macro=true";
import { default as indexz3Eoqr0Yqko21Tkso13WZNB6o_gEePVcfQ9I4FAqaokMeta } from "/app/apps/web-commerce/pages/gift-cards/index.vue?macro=true";
import { default as _91code_93H7X9Ixd_Gb_450QLgs7jaozc9ko5tCRZw_45raW3GtVYoLQMeta } from "/app/apps/web-commerce/pages/order-detail/[code].vue?macro=true";
import { default as accounts_45subscriptionss7YSkGw92SKDAklAjsG0Z4r_45lOMCiHABCG7CtfPAZ7YMeta } from "/app/apps/web-commerce/pages/accounts-subscriptions.vue?macro=true";
export default [
  {
    name: "all",
    path: "/all",
    component: () => import("/app/apps/web-commerce/pages/all.vue")
  },
  {
    name: "otp",
    path: "/otp",
    component: () => import("/app/apps/web-commerce/pages/otp.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/apps/web-commerce/pages/auth.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/web-commerce/pages/index.vue")
  },
  {
    name: "topup",
    path: "/topup",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/topup.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/apps/web-commerce/pages/[slug].vue")
  },
  {
    name: "custom",
    path: "/custom",
    component: () => import("/app/apps/web-commerce/pages/custom.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/orders.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/apps/web-commerce/pages/search.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/wallet.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/app/apps/web-commerce/pages/library.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/app/apps/web-commerce/pages/payment.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/profile.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/app/apps/web-commerce/pages/messages.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/dashboard.vue")
  },
  {
    name: "order-id",
    path: "/order/:id()",
    component: () => import("/app/apps/web-commerce/pages/order/[id].vue")
  },
  {
    name: "transactions",
    path: "/transactions",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/transactions.vue")
  },
  {
    name: "giftcard-id",
    path: "/giftcard/:id()",
    component: () => import("/app/apps/web-commerce/pages/giftcard/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: {"middleware":"auth"},
    component: () => import("/app/apps/web-commerce/pages/notifications.vue")
  },
  {
    name: "online-payment",
    path: "/online-payment",
    component: () => import("/app/apps/web-commerce/pages/online-payment.vue")
  },
  {
    name: "order-old-id",
    path: "/order-old/:id()",
    component: () => import("/app/apps/web-commerce/pages/order-old/[id].vue")
  },
  {
    name: "category-slug",
    path: "/category/:slug()",
    component: () => import("/app/apps/web-commerce/pages/category/[slug].vue")
  },
  {
    name: "pay-result-ok",
    path: "/pay-result/:ok()",
    component: () => import("/app/apps/web-commerce/pages/pay-result/[ok].vue")
  },
  {
    name: "gift-cards",
    path: "/gift-cards",
    component: () => import("/app/apps/web-commerce/pages/gift-cards/index.vue")
  },
  {
    name: "order-detail-code",
    path: "/order-detail/:code()",
    component: () => import("/app/apps/web-commerce/pages/order-detail/[code].vue")
  },
  {
    name: "accounts-subscriptions",
    path: "/accounts-subscriptions",
    component: () => import("/app/apps/web-commerce/pages/accounts-subscriptions.vue")
  }
]